export const labels = {
  streetAddress: 'Street address',
  apt: 'Apt/Suite (optional)',
  city: 'City',
  state: 'State',
  zip: 'Zip',
}

export default labels
